module.exports = __webpack_public_path__ + "img/about-5.aa6f3323.png";